define((require) => {
    "use strict";

    const _                         = require("underscore");
    const CustomJsAction            = require("shared/ui/experience/action/customJs/CustomJsAction");
    const SalesforceCommerceQuickViewAction = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewAction");
    const JsAction                  = require("shared/ui/experience/action/js/JsAction");
    const LightboxAction            = require("shared/ui/experience/action/lightbox/LightboxAction");
    const LinkAction                = require("shared/ui/experience/action/link/LinkAction");
    const ProductCustomJsAction     = require("shared/ui/experience/action/product/ProductCustomJsAction");
    const ProductLightboxAction     = require("shared/ui/experience/action/product/ProductLightboxAction");
    const ProductLinkAction         = require("shared/ui/experience/action/product/ProductLinkAction");
    const SceneNavigationAction     = require("shared/ui/experience/action/sceneNavigation/SceneNavigationAction");

    const ACTION_CLASSES = [
        CustomJsAction,
        SalesforceCommerceQuickViewAction,
        JsAction,
        LightboxAction,
        LinkAction,
        ProductCustomJsAction,
        ProductLightboxAction,
        ProductLinkAction,
        SceneNavigationAction
    ];

    /**
     * A factory/store for creating actions.
     *
     * @class ActionFactory
     */
    const ActionFactory = {

        /**
         * Returns the associated <tt>Action</tt> class/constructor function
         * from the specified type.
         *
         * @param  {String} type The action string representation.
         * @return {Function}    The action class/constructor function.
         */
        fromType(type) {
            return _.find(ACTION_CLASSES, (klass) => klass.TYPE === type);
        },

        /**
         * Creates a new <tt>Action</tt> instance from the specified type with the
         * specified (optional) options.
         *
         * @param  {String} type    The action type, e.g. <tt>LinkAction.TYPE</tt>.
         * @param  {Object} options Optional options passed to the action instance.
         * @return {Action}         A new <tt>Action</tt> instance.
         */
        newActionFromType(type, options) {
            const ActionClass = ActionFactory.fromType(type);
            return ActionClass ? new ActionClass(options || {}) : null;
        }
    };

    return ActionFactory;
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/ActionFactory.js